export default __webpack_public_path__ + "static/media/Minicard_Ac.0852e049.svg";